module.exports = __webpack_public_path__ + "img/jhcd.f4e45ad2.png";